(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceTypeDeleteController',CrmReferralSourceTypeDeleteController);

    CrmReferralSourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralSourceType'];

    function CrmReferralSourceTypeDeleteController($uibModalInstance, entity, CrmReferralSourceType) {
        var vm = this;

        vm.crmReferralSourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralSourceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
